module.exports = __webpack_public_path__ + "static/media/logo.09b71574.png";